/**
 * User avatar, rendered as a circle. Currently just a solid grey color, but
 * will be updated to intelligently render the supplied user's FB profile image
 * or a fallback image of some sort, tbd.
 *
 * @module components/Avatar
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './Avatar.scss';

class Avatar extends React.Component {
  // TODO: Support user images
  static propTypes = {
    qaTag: PropTypes.string,
    onClick: PropTypes.func,
    listenerImgUrl: PropTypes.string,
    inDropdown: PropTypes.bool,
  };

  render() {
    let avatarButton;
    const classes = classNames('Avatar', {
      'Avatar--clickable': this.props.onClick,
      'Avatar--inDropdown': this.props.inDropdown,
    });
    const props = {
      onClick: this.props.onClick || (() => {}),
      className: classes,
    };

    if (this.props.onClick) {
      avatarButton = (
        <button type='button' aria-haspopup='true' {...props} data-qa={this.props.qaTag}>
          {this.props.listenerImgUrl && (
            <img className='Avatar__img' src={this.props.listenerImgUrl} alt='Account Menu' />
          )}
        </button>
      );
    } else {
      avatarButton = (
        <span {...props}>
          {this.props.listenerImgUrl && (
            // eslint-disable-next-line jsx-a11y/alt-text
            <img
              className='Avatar__img'
              src={this.props.listenerImgUrl}
              data-qa={this.props.qaTag}
            />
          )}
        </span>
      );
    }
    return avatarButton;
  }
}

export default Avatar;
